<script>
import { sentenceLinesOf } from '@/utils/sentenceLines'

/**
 * 안내 한 칸을 문장마다 한 줄로 그린다(나누기는 `utils/sentenceLines` 한 곳). 줄 사이에는 원문의 빈칸을 남긴다 — 줄이 블록이라 화면에는
 * 보이지 않고, 글자(`textContent`)는 원문 그대로다. 받는 글자는 부른 화면이 번역해 준다.
 */
export default {
  name: 'SentenceLines',
  props: {
    text: { type: String, default: '' },
  },
  computed: {
    lines() {
      return sentenceLinesOf(this.text)
    },
  },
  render(h) {
    const children = []
    this.lines.forEach((line, index) => {
      if (index > 0) children.push(' ')
      children.push(h('span', { class: 'sentence-lines__line' }, line))
    })
    return h('span', { class: 'sentence-lines' }, children)
  },
}
</script>

<style scoped>
.sentence-lines__line {
  display: block;
  text-wrap: pretty;
}
</style>
